import axios from "axios";

export interface PresignedUpload {
    url: string
    key: string
}

export const uploadFile = async (uploadType: string, file: File): Promise<string> => {
    const presignedUploadResponse = await axios.get(`/api/files/upload/${uploadType}`)
    const presignedUpload: PresignedUpload = presignedUploadResponse.data
    await axios.put(presignedUpload.url, file, { headers: { 'Content-Type': file.type }})
    return presignedUpload.key
}